(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["personalised-husband"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener("DOMContentLoaded", function () {
  const variantIdInput = document.getElementById("variant-id");
  const shellfill = document.getElementById("shell-fill");
  const ammntfill = document.getElementById("filling-amount");
  const expressCheckoutButtons = document.querySelectorAll(".express-checkout");
  const sizeVal = document.getElementById("size-e");
  
  const swatches = document.querySelectorAll(".swatchs-color");
  const tabbtns = document.querySelectorAll(".tab-bttn");
  const optionselect = document.querySelectorAll(".option_selections");
  const optionfill = document.querySelectorAll(".option-filling");


    tabbtns.forEach(tabbtn => {
  tabbtn.addEventListener("click", function () {
    
    let selectedVariantId = this.getAttribute("data-varid");
    let selctedproductId = this.getAttribute("data-prid");
    let prImage = this.getAttribute("data-images");
    let shellfillImage = this.getAttribute("data-shellfill");
    let fillammount = this.getAttribute('data-fillam');
    let prSize = this.getAttribute('data-size');


    document.querySelector('.imagee-wrapss img').src = prImage;
    document.querySelector('.image-section-option img').src = shellfillImage;
    document.querySelector('.option-main-image img').src = fillammount;

    // Update Hidden Variant ID Input
    variantIdInput.value = selectedVariantId;
    sizeVal.value = prSize;
 
        // Hide all .stepp-selctions-wrapps elements
        document.querySelectorAll('.stepp-selctions-wrapps').forEach(wrapper => {
          wrapper.style.display = "none";
        }); 
    
        // Show the selected .stepp-selctions-wrapps
        let selectedStep = document.querySelector(`.stepp-selctions-wrapps[data-prid="${selctedproductId}"]`);
        if (selectedStep) {
          selectedStep.style.display = "block";
        }

        tabbtns.forEach(item => item.classList.remove("tabb-btnn-active"));
        this.classList.add("tabb-btnn-active");

        swatches.forEach(item => item.classList.remove("swatch-activessw"));
        document.querySelectorAll('.swatchs-color[data-varid="'+ selectedVariantId +'"]').forEach(swatch => {
  swatch.classList.add("swatch-activessw");
});
  
                  document.querySelectorAll('.pr-selection-wraps').forEach(arrowi => {
          arrowi.classList.remove("arrow-indicator");
        });
      
      document.querySelectorAll('.pr-selection-wraps[data-prid="'+ selctedproductId +'"]').forEach(arrowi => {
          arrowi.classList.add("arrow-indicator");
        });
           
});
}); 



    optionselect.forEach(optionselec => {
  optionselec.addEventListener("click", function () {
    
    let optionval = this.getAttribute("data-title");
    

    // Update Hidden Variant ID Input
    shellfill.value = optionval;


    optionselect.forEach(item => item.classList.remove("option_select_active"));
    this.classList.add("option_select_active");
   

});
});


optionfill.forEach(optionf => {
  optionf.addEventListener("click", function () {
    
    let optionamval = this.getAttribute("data-title");
    

    // Update Hidden Variant ID Input
    ammntfill.value = optionamval;


    optionfill.forEach(item => item.classList.remove("option-fill-active"));
    this.classList.add("option-fill-active");
   

});
});
    
    
    
  // Handle Variant Selection
  swatches.forEach(swatch => {
    swatch.addEventListener("click", function () {
      let selctedproductId = this.getAttribute("data-prid");
      let selectedVariantId = this.getAttribute("data-varid");
      let selectedImgUrl = this.getAttribute("data-imgurl");
      let varpr = this.getAttribute("data-prid");
 
      // Update Hidden Variant ID Input 
      variantIdInput.value = selectedVariantId;

      // Update Main Product Image (Optional)
      document.querySelector('.pr-image-wraps-selections[data-prid="'+ varpr +'"] img').src = selectedImgUrl;
 
      // Remove active class from all swatches and add to the selected one
      swatches.forEach(item => item.classList.remove("swatch-activessw"));
      this.classList.add("swatch-activessw");

              document.querySelectorAll('.pr-selection-wraps').forEach(arrowi => {
          arrowi.classList.remove("arrow-indicator");
        });
         
      document.querySelectorAll('.pr-selection-wraps[data-prid="'+ selctedproductId +'"]').forEach(arrowi => {
          arrowi.classList.add("arrow-indicator");
        });

      
    });
  });


    expressCheckoutButtons.forEach(expresbtn => {
  expresbtn.addEventListener("click", function () {
    if (!variantIdInput) {
      console.error("Variant ID input field is missing.");
      return;
    }

    let selectedVariantId = variantIdInput.value;
    if (!selectedVariantId) {
      alert("Please select a variant before proceeding.");
      return;
    } 

    let properties = {
      Size: document.getElementById("size-e")?.value || "",
      "Shell filling": document.getElementById("shell-fill")?.value || "",
      "Filling Amount": document.getElementById("filling-amount")?.value || "",
    };

    // Add product to cart and redirect to checkout
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: selectedVariantId,
            quantity: 1,
            properties: properties,
          },
        ], 
      }),
    })
    .then(response => response.json())
    .then(() => {
      window.location.href = "/checkout";
    })
    .catch(error => console.error("Error:", error));
  });
});

    
});

 

  } catch(e) { console.error(e); }
})();
})();
